import React from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import { TVehicle } from "types";
import { ConfigurationStore } from "stores";
import { getJsonLd } from "./json-ld";

interface IHeader {
  vehicle: TVehicle;
}

const Header: React.FC<IHeader> = ({ vehicle }): JSX.Element => {
  const configuration = React.useContext(ConfigurationStore);
  const { formatMessage: t } = useIntl();

  const href = window.location.href;

  const { wgnr, modell, version = "", picturesCount = 0 } = vehicle;

  const preview =
    picturesCount > 0 ? vehicle.picturesPath + vehicle.wgnr + "_1.jpg" : null;
  const title = configuration.application.title || "carbando catalog";
  const googleSiteVerification =
    configuration.application?.googleSiteVerification || undefined;
  const jsonLd = getJsonLd(vehicle, t);

  return (
    <>
      <h1 className="aria-hidden">
        {t(
          {
            id: "pages.detail.title",
            defaultMessage:
              "Detailansicht des Fahrzeugs {marke} {modell} in der Version {version} mit der Wagennummer {wgnr}",
          },
          { marke: modell.marke.name, modell: modell.name, version, wgnr },
        )}
      </h1>
      <Helmet>
        {googleSiteVerification && (
          <meta
            name="google-site-verification"
            content={googleSiteVerification}
          />
        )}
        {configuration.application.inline === false && (
          <>
            <title>{`${title} - ${modell.marke.name} ${modell.name} - ${version} - ${wgnr}`}</title>
            <meta
              property="og:title"
              content={`${title} - ${modell.marke.name} ${modell.name} - ${version} - ${wgnr}`}
            />
            git ic -am"
            <meta property="og:url" content={href} />
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content={title} />
            <meta
              property="og:description"
              content={`${title} - ${modell.marke.name} ${modell.name} - ${version} - ${wgnr}`}
            />
            {preview && <meta property="og:image" content={preview} />}
            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
          </>
        )}
      </Helmet>
    </>
  );
};

export default Header;
